module.exports = __webpack_public_path__ + "img/people-23-min.21df3416.png";